export const colors = {
  brand: '#093C8F',
  brandLight: '#2053a7',
  secondary: 'rgba(255,162,0,0.9)',
  secondaryLight: '#ffa200c9',
  lightBlue: '#e6ecf4',
  cardLightBlue: '#E7F0FC',
  green: '#4EB57B',
  greenLight: '#65cd91',
  greenBanner: '#dbf0e4',
  white: '#FFFFFF',
  lightGrey: '#F8F8F8',
  darkGrey: '#666666',
  black: '#141125',
  error: '#E73024',
  errorLight: '#E73024',
};
